/**
 * Composable для работы с переменными окружения (env variables)
 * Предоставляет безопасный способ получения переменных окружения Vite с префиксом VITE_
 *
 * @returns {Object} Объект с функцией getEnvVar
 *
 * @example
 * const { getEnvVar } = useEnvVariable()
 *
 * // Получение переменной окружения
 * const apiUrl = getEnvVar('API_URL')
 * // Результат: значение из VITE_API_URL или ошибка, если переменная не существует
 */
export const useEnvVariable = () => {
  /**
   * Получает значение переменной окружения с префиксом VITE_
   * @param {string} key - Название переменной без префикса VITE_
   * @returns {string} Значение переменной окружения
   * @throws {Error} Если переменная не найдена
   * @example getEnvVar('API_URL') // вернет значение VITE_API_URL
   * @example getEnvVar('DEBUG') // вернет значение VITE_DEBUG или вызовет ошибку, если переменная не определена
   */
  const getEnvVar = (key) => {
    const envKey = `VITE_${key}`;

    if (import.meta.env[envKey] === undefined) {
      throw new Error(`Env variable ${key} is required`);
    }

    return import.meta.env[envKey] || "";
  };

  return {
    getEnvVar,
  };
};
